import { isRecordWithBody, isJsonTypeBody, parseHeaders } from '../';

import { Body, RecordList } from 'types/index';
import { Har, Entry, PostData, Content } from '../types';
import { maskingRecords } from '../../masked';
import { Masks } from '../../masked/types';
import { PAGES_REF_ID } from '../../constants';

/**
 * @param body
 */
function parseBody(body: Body): PostData {
  if (isJsonTypeBody(body)) {
    return {
      mimeType: 'application/json;charset=utf-8',
      params: [],
      text: body as string,
    };
  }

  return {
    mimeType: '',
    params: [],
    text: '',
  };
}

/**
 * @param responseText
 */
function parseContent(responseText: string): Content {
  try {
    JSON.parse(responseText);
    return {
      mimeType: 'application/json;charset=utf-8',
      text: responseText,
      size: 0,
    };
  } catch {
    return {
      mimeType: '',
      text: '',
      size: 0,
    };
  }
}

/**
 * @param records
 * @param masks
 */
function recordsToEntries(records: RecordList, masks: Masks): Array<Entry> {
  return records.map((record) => ({
    startedDateTime: record.startDateTime
      ? record.startDateTime
      : new Date().toISOString(),
    time: 0,
    pageref: PAGES_REF_ID,
    response: {
      status: record.status,
      statusText: record.statusText,
      httpVersion: 'HTTP/1.1',
      cookies: [],
      headers: parseHeaders(record.responseHeaders),
      content: parseContent(maskingRecords(record.responseText, masks)),
      redirectURL: '',
      headersSize: 0,
      bodySize: 0,
    },
    request: {
      method: record.method,
      url: record.responseURL,
      httpVersion: 'HTTP/1.1',
      cookies: [],
      headers: [],
      queryString: [],
      headersSize: 0,
      bodySize: 0,
      postData: isRecordWithBody(record) ? parseBody(record.body) : undefined,
    },
    cache: {},
    timings: {
      wait: 0,
      receive: 0,
    },
  }));
}

/**
 * @param records
 * @param startDateTime.customCreator
 * @param masks
 */
function harFormatter(records: RecordList, masks: Masks): Har {
  return {
    log: {
      version: '1.2',
      creator: {
        name: '@korus/request-sniffer',
        version: '1.0.0',
      },
      pages: [
        {
          startedDateTime: new Date().toISOString() as string,
          id: PAGES_REF_ID,
          title: window.location.toString(),
          pageTimings: {
            onContentLoad: -1,
            onLoad: -1,
          },
        },
      ],
      entries: recordsToEntries(records, masks),
    },
  };
}

export { harFormatter };
